import {Component, OnInit, OnDestroy} from '@angular/core';
import {Subscription} from "rxjs";
import {FieldType, FormlyFieldConfig} from '@ngx-formly/core';
import {toOptions} from "@app/@core/services/formly-helpers";
import {Observable} from "rxjs/internal/Observable";
import {Cacheable} from 'ts-cacheable';
import {ApiService} from "@app/@core/services/api.service";
import {Supplier} from "@app/@core/domain/supplier.model";

@Component({
  selector: 'app-custom-select',
  templateUrl: './custom-select.component.html',
  styleUrls: ['./custom-select.component.scss']
})
export class CustomSelectComponent extends FieldType<FormlyFieldConfig> implements OnInit {
  sub: Subscription = new Subscription();
  handlers: any;
  show = true;

  constructor(private apiService: ApiService) {
    super();
    this.handlers = {
      'category-types': this.CategoryTypes,
      'supplier': this.Supplier
    };
  }


  ngOnInit(): void {

    if (this.to.source) {
      this.handlers[this.to.source]();
    }
  }

  CategoryTypes = () => {
    this.sub.add(this.getCategory().subscribe(types => {
      this.field.templateOptions.options = types.map(item => ({
        label: item.title?.en, // flatten here
        value: item
      }));
    }));
  };
  Supplier = () => {
    this.sub.add(this.getSupplier().subscribe((types: Supplier[]) => {
      this.field.templateOptions.options = types
        .filter(item => item.active === true)
        .map(item => ({
          label: item?.name,
          value: item
        }));
    }));
  };

  @Cacheable()
  private getCategory(): Observable<any> {
    return this.apiService.get(`/api/internal/category/get-all`);
  }

  @Cacheable()
  private getSupplier(): Observable<any> {
    return this.apiService.get(`/api/internal/supplier/all-list`);
  }

  compareWith = (o1, o2) => {
    return this.to.compareWith ? this.to.compareWith(o1, o2) : (o1 === o2);
  }

  selectChange(e: Event): void {
    this.field?.templateOptions?.change?.(this.field, e);
  }
}
